import React from "react";
import ComingSoonComponent from "../../common/ComingSoonComponent/ComingSoonComponent";
export default function InsightsPage(){
  return (
    <div className="pp-page">
      <div className="pp-page-header d-flex align-items-center justify-content-between">
        <h1 className="pp-page-title">Insights</h1>
        <div className="pp-page-actions"></div>
      </div>
      <ComingSoonComponent/>
    </div>
  );
}
